module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAOCAYAAABdC15GAAAACXBIWXMAAAsSAAALEgHS3X78AAAAlElEQVRIx83VsQ3CMBCF4f8QA3iUbEDYxCMwAiNkhIyUETICSDRUP40LJwp17knX+DWfbFkXKmcnIiYA9bHvruTIANwioqh106inDzACtpk3XQZgQ9YO+UwHPEDWdMCGnHokwNwdZJvvhdz5ZHveAizt9hagZMW9gCHNJ/mHywQ8xKlEkl0s8AZGdcm4i+/Aqq774gc1iqw1YE63CAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow.png
// module id = 292
// module chunks = 0